// import { competency_permission } from "./competency.permission";
import { role_permission } from "./role.permission";

export const jobfamily_permission= {
    requried_permission:['view_jobfamily', 'add_jobfamily', 'change_jobfamily', 'delete_jobfamily','view_competency', 'add_competency', 'change_competency', 'delete_competency',...role_permission.requried_permission],
    job_family_details_permission:['view_jobfamily','view_competency','view_role'],
    edit_job_family:['change_jobfamily'],
    delete_job_family:['delete_jobfamily']
}